import styled from 'styled-components';

const Container = styled.div`
  height: 20px;
  width: 20px;
  text-align: center;
  svg {
    height: 10px;
    width: 10px;
    fill: ${(p) => p.theme.color.red};
  }
  &:hover  {
    cursor: pointer;
  }
`;

export const Styled = {
  Container,
};
